import { createGlobalStyle } from "styled-components";
import { designSystemVars as vars } from "./design-system";

export const GlobalFocusStyle = createGlobalStyle`
  button:focus,
  [role="button"]:focus,
  [tabindex]:not([tabindex="-1"]):not([role="cell"]):not([role="columnheader"]):not([data-suppress-focus-ring]):not(td):not(th):focus,
  input[type="checkbox"]:focus,
  input[type="radio"]:focus {
    outline: none;
  }

  button:focus-visible,
  [role="button"]:focus-visible,
  [tabindex]:not([tabindex="-1"]):not([role="cell"]):not([role="columnheader"]):not([data-suppress-focus-ring]):not(td):not(th):focus-visible,
  input[type="checkbox"]:focus-visible,
  input[type="radio"]:focus-visible {
    outline: none;
    box-shadow: ${vars.shadow.focus};
  }

  button:focus:not(:focus-visible),
  [role="button"]:focus:not(:focus-visible),
  [tabindex]:not([tabindex="-1"]):not([role="cell"]):not([role="columnheader"]):not([data-suppress-focus-ring]):not(td):not(th):focus:not(:focus-visible),
  input[type="checkbox"]:focus:not(:focus-visible),
  input[type="radio"]:focus:not(:focus-visible) {
    outline: none;
    box-shadow: none;
  }
`;
